var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.style),attrs:{"src":_vm.baseUrl + _vm.url,"alt":"加载中..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }